import { useState } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import { Container } from '@mui/material';

import Logo from 'src/components/logo';

import Nav from './nav';
import LanguagePopover from './common/language-popover';

// ----------------------------------------------------------------------

export function NoNavLayout({ children }) {
  return (
    <Container sx={{ p: 0 }}>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: { xs: 1, md: 2 },
          zIndex: 1000, // Ensure it stays on top of other content
        }}
      >
        <Logo
          sx={{
            ml: { xs: 1, md: 2 },
          }}
        />
        <Box
          sx={{
            mr: { xs: 1, md: 2 },
          }}
        >
          <LanguagePopover />
        </Box>
      </Box>

      <Container sx={{ height: '100%', p: 0 }}>{children}</Container>
    </Container>
  );
}

export function AppLayout({ children }) {
  const [openNav, setOpenNav] = useState(false);

  return (
    <Box
      sx={{
        minHeight: 1,
        display: 'flex',
        maxHeight: '100vh',
        flexDirection: { xs: 'column', lg: 'row' },
      }}
    >
      <Nav openNav={openNav} setOpenNav={setOpenNav} />

      <Container sx={{ p: 0, flex: 1 }}>{children}</Container>
    </Box>
  );
}

NoNavLayout.propTypes = {
  children: PropTypes.node,
};

AppLayout.propTypes = {
  children: PropTypes.node,
};
